export default __webpack_public_path__ + "static/media/tabok.beb8c62c.mp4";